package devxertech.com.pages.industries.sportsIndustry.sportsServices

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span

@Composable
fun SportsServices(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 55.px,
                bottom = if (breakpoint < Breakpoint.MD) 10.px  else 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "SPORTS SOFTWARE DEVELOPMENT SERVICES WE OFFER  ",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 16.px,
                textAlign = TextAlign.Center,
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Span(
                    attrs = Modifier.fillMaxWidth().display(DisplayStyle.Flex)
                        .flexDirection(if (breakpoint <= Breakpoint.LG) FlexDirection.Column else FlexDirection.Row)
                        .toAttrs()
                ) {
                    FieldTitleTextNormalSimple(
                        "SEAMLESS, SMART, AND UNIQUELY ",
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontFamily = Constants.ROBOTO_FONT,
                        fontSize = if (breakpoint > Breakpoint.MD) 35.px else 18.px,
                        fontWeight = 700,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        " PERSONALIZED",
                        color = sitePalette.primary.rgb,
                        fontFamily = Constants.ROBOTO_FONT,
                        fontSize = if (breakpoint > Breakpoint.MD) 35.px else 18.px,
                        fontWeight = 700,
                        textAlign = TextAlign.Center
                    )
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(bottom = if (breakpoint < Breakpoint.MD) 0.px else if (window.screen.width > 1600) 10.px else 0.px,
                        top = if (breakpoint < Breakpoint.MD) 25.px else 40.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                TeamService(
                    image = Res.Image.sport_1,
                    title = "Sports Management \n" +
                            "Software",
                    description = "Custom platforms for managing teams, leagues, scheduling, and player performance tracking, with " +
                            "automated workflows and real-time reporting.",
                )
                TeamService(
                    image = Res.Image.sport_2,
                    title = "Fantasy Sports App\n" +
                            " Development",
                    description = "Scalable and engaging fantasy sports platforms with real-time data integration, secure payment " +
                            "gateways, and interactive user experiences.",
                )
                TeamService(
                    image = Res.Image.sport_3,
                    title = "Sports Analytics &\n" +
                            " AI Solutions",
                    description = "Advanced data-driven insights for player performance, game strategy, and fan engagement, using machine learning, " +
                            "predictive analytics, and AI-powered decision-making.",
                )
                if (window.screen.width < 1600) {
                    TeamService(
                        image = Res.Image.sport_4,
                        title = "Live Streaming &\n" +
                                " Broadcasting Solutions",
                        description = " High-quality streaming platforms with real-time analytics, multi-platform support," +
                                " and interactive features like live commentary and fan engagement tools.",
                    )
                    TeamService(
                        image = Res.Image.sport_5,
                        title = "Sports E-commerce &\n" +
                                "Ticketing Platforms",
                        description = "Online solutions for merchandise sales, event ticketing, " +
                                "and fan engagement, with seamless payment integration, personalized",
                        modifier = Modifier.padding(bottom = 40.px)

                    )
                }
            }
            if (window.screen.width > 1600) {
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .padding(top = 0.px, bottom = if (window.screen.width > 1600) 0.px else 70.px).display(DisplayStyle.Flex)
                        .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        image = Res.Image.sport_4,
                        title = "Live Streaming &\n" +
                                " Broadcasting Solutions",
                        description = " High-quality streaming platforms with real-time analytics, multi-platform support," +
                                " and interactive features like live commentary and fan engagement tools.",

                        )
                    TeamService(
                        image = Res.Image.sport_5,
                        title = "Sports E-commerce &\n" +
                                "Ticketing Platforms",
                        description = "Online solutions for merchandise sales, event ticketing, " +
                                "and fan engagement, with seamless payment integration, personalized",

                        )
                }
            }
        }
    }
}